// components/SignaturePad.js
import { forwardRef, useImperativeHandle, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Box, Button, Typography, Paper } from "@mui/material";

const SignaturePad = forwardRef(({ height = 200 }, ref) => {
  const sigCanvas = useRef(null);

  useImperativeHandle(ref, () => ({
    isEmpty: () => sigCanvas.current?.isEmpty(),
    clear: () => sigCanvas.current?.clear(),
    getSignature: () =>
      sigCanvas.current
        ? sigCanvas.current.getCanvas().toDataURL("image/png")
        : null,
  }));

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Typography variant="subtitle1">Sign Here:</Typography>
      <Paper elevation={3} sx={{ width: "100%", maxWidth: 600, height, p: 1 }}>
        <SignatureCanvas
          ref={sigCanvas}
          penColor="black"
          canvasProps={{
            width: 580,
            height: height - 20,
            className: "sigCanvas",
          }}
        />
      </Paper>
      <Box display="flex" gap={2}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => sigCanvas.current?.clear()}
        >
          Clear
        </Button>
      </Box>
    </Box>
  );
});

export default SignaturePad;
